export default "__VITE_ASSET__CZlTpCN2__"